export const MEMBER_ROLES = ['OWNER', 'ADMIN', 'SELLER', 'FINANCE', 'AGENT'] as const;
export type MemberRole = (typeof MEMBER_ROLES)[number];

export const PERMISSIONS = [
  'tenant:read',
  'tenant:update',
  'dashboard:read',
  'notifications:read',
  'catalog:read',
  'catalog:write',
  'customers:read',
  'customers:write',
  'team:read',
  'team:manage',
  'sales:quick',
  'billing:read',
  'billing:manage',
  'storefront:read',
  'storefront:manage',
  'bookings:read',
  'bookings:write',
  'checkout:payment-account',
  'orders:read',
  'orders:write',
  'orders:refund',
  'inventory:read',
  'inventory:adjust',
  'finance:read',
  'finance:write',
  'fiscal:read',
  'fiscal:write',
  'fiscal:certificate',
  'inbox:read',
  'inbox:write',
  'inbox:channels',
  'ads:read',
  'ads:write',
] as const;

export type Permission = (typeof PERMISSIONS)[number];

const ALL: readonly Permission[] = PERMISSIONS;

/** Mapa papel → permissões (seção 5.4 do guia). */
export const ROLE_PERMISSIONS: Record<MemberRole, readonly Permission[]> = {
  // Tudo, inclusive assinatura, conta de recebimento e certificado
  OWNER: ALL,
  // Tudo, exceto assinatura e dados bancários
  ADMIN: ALL.filter(
    (p) => p !== 'billing:read' && p !== 'billing:manage' && p !== 'checkout:payment-account',
  ),
  // Pedidos, clientes, produtos (leitura), atendimento
  SELLER: [
    'tenant:read',
    'dashboard:read',
    'notifications:read',
    'catalog:read',
    'customers:read',
    'customers:write',
    'sales:quick',
    'orders:read',
    'orders:write',
    'bookings:read',
    'bookings:write',
    'inbox:read',
    'inbox:write',
  ],
  // Financeiro, notas fiscais, relatórios
  FINANCE: [
    'tenant:read',
    'dashboard:read',
    'notifications:read',
    'catalog:read',
    'customers:read',
    'orders:read',
    'inventory:read',
    'finance:read',
    'finance:write',
    'fiscal:read',
    'fiscal:write',
  ],
  // Atendimento e leitura de pedidos e da agenda
  AGENT: [
    'tenant:read',
    'notifications:read',
    'catalog:read',
    'customers:read',
    'orders:read',
    'bookings:read',
    'inbox:read',
    'inbox:write',
  ],
};

export function roleHasPermission(role: MemberRole, permission: Permission): boolean {
  return ROLE_PERMISSIONS[role].includes(permission);
}
